<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb :page-title="$t('Ganttproject')" :directory="[$t('gantts'), $t('people')]" :icon="'users'" />
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="text-sm-right mb-primary mb-sm-0 mb-md-0">

          <button type="button" class="btn btn-primary btn-with-shadow" data-toggle="modal" @click="openModal()">
            {{ $t("add_gantt") }}
          </button>
        </div>
      </div>
    </div>
    <app-table :id="tableId" :options="options" @action="getAction" />

    <app-gantt-modal v-if="isGanttModalActive" :table-id="tableId" :copy="copy" :selected-url="selectedUrl" @close-modal="closeModal" />
    <app-gantt-type-modal v-if="isTypeModalActive" :table-id="gantttableId" @close-modal="closeTypeModal" />
    <app-confirmation-modal v-if="confirmationModalActive" modal-id="gantt-delete-modal" @confirmed="confirmed"
      @cancelled="cancelled" />

    <app-common-activity-modal v-if="ganttActivitiesModal" :activity="rowData" :selected-url="editedUrl"
      @close-modal="closeActivityModal" />

  </div>
</template>
<script>
import CoreLibrary from "@core/helpers/CoreLibrary.js";
import { formatDateToLocal, collection, urlGenerator, numberWithCurrencyMuseum } from "@app/Helpers/helpers";
import { mapGetters } from "vuex";
import { owner, ganttType } from "@app/Mixins/Global/FilterMixins";
import { getCustomFileds } from "@app/Mixins/Global/CustomFieldMixin";
import { DeleteMixin } from "@app/Mixins/Global/DeleteMixin";
export default {
  name: "Person",
  extends: CoreLibrary,
  mixins: [owner, ganttType, getCustomFileds, DeleteMixin],
  data() {
    return {
      numberWithCurrencyMuseum,
      formatDateToLocal,
      urlGenerator,
      isGanttModalActive: false,
      isTypeModalActive: false,
      tableId: "gantt-modal",
      gantttableId: "gantt-modal",
      confirmationModalActive: false,
      isQuickViewModalActive: false,
      organizationModal: false,
      ganttActivitiesModal: false,
      editedUrl: "",
      viewAllDeal: false,
      viewAllFollower: false,
      isNoteModal: false,
      noteRowData: null,
      ganttId: null,
      copy:false,
      selectedUrl: "",
      activityData: {},
      followerUrl: "",
      commonColumn: [
        {
          title: this.$t("name"),
          type: "link",
          key: "name",
          modifier: (value, row) => {
            return `crm/gantts/${row.id}/edit`;
          },
        },
        {
          title: this.$t("lead_groups"),
          type: "custom-html",
          key: "gantt_type",
          modifier: (value, row) => {
            return value
              ? `<span class="badge badge-pill badge-${value.class ?? "secondary"}">${value.name
              }</span>`
              : "-";
          },
        },
        {
          title: this.$t("gantt_status"),
          type: "custom-html",
          key: "status",
          modifier: (value, row) => {
            return value
              ? `<span class="badge badge-pill badge-${value == 14 ? "secondary" : "success"}">${value == 14 ? this.$t('gantt_status_todo') : this.$t('gantt_status_done')}</span>`
              : "-";
          },
        },
        {
          title: this.$t("gantt_deal"),
          type: "custom-html",
          key: "deal",
          modifier: (value, row) => {
            return value
              ? `<span class="badge badge-pill badge-${value == 1 ? "primary" : "success"}">${value == 1 ? this.$t('gantt_deal_off') : this.$t('gantt_deal_on')}</span>`
              : "-";
          },
        },






        {
          title: this.$t("gantt_leson_start"),
          type: "custom-html",
          key: "start",
          modifier: (value, row) => {
            return value
              ? `<span class="text-nowrap">${formatDateToLocal(row.start)}</span>`
              : "-";
          },
        },
        {
          title: this.$t("gantt_leson_end"),
          type: "custom-html",
          key: "end",
          modifier: (value, row) => {
            return value
              ? `<span class="text-nowrap">${formatDateToLocal(row.end)}</span>`
              : "-";
          },
        },

        {
          title: this.$t("gantt_leson_total"),
          type: "custom-html",
          key: "total",
          modifier: (value, row) => {
            return value
              ? `<span class="text-nowrap">${numberWithCurrencyMuseum(row.total)}</span>`
              : "-";
          },
        },
        {
          title: this.$t("gantt_deal_total"),
          type: "custom-html",
          key: "total_deal",
          modifier: (value, row) => {
            return value
              ? `<span class="text-nowrap">${numberWithCurrencyMuseum(row.total_deal)}</span>`
              : "-";
          },
        },

        {
          title: this.$t("action"),
          type: "action",
          key: "invoice",
          isVisible: true,
        },
      ],
      options: {
        name: this.$t("gantt_table"),
        url: "crm/gantts",
        showHeader: true,
        countView: true,
        columns: [],
        filters: [
          {
            title: this.$t("created_date"),
            type: "range-picker",
            key: "date",
            option: ["today", "thisMonth", "last7Days", "thisYear"],
          },
          {
            title: this.$t("owner"),
            type: "checkbox",
            key: "owner_is",
            option: [],
          },
          {
            title: this.$t("lead_group"),
            type: "checkbox",
            key: "gantt_type",
            option: [],
          },
        ],
        showSearch: true,
        showFilter: true,
        paginationType: "pagination",
        responsive: false,
        rowLimit: 20,
        showAction: true,
        orderBy: "desc",
        actionType: "dropdown",
        actions: [
          {
            title: this.$t("edit"),
            icon: "edit",
            type: "modal",
            component: "app-gantt-modal",
            modalId: "gantt-modal",
            url: "",
          },
          {
            title: this.$t("copy"),
            icon: "edit",
            type: "modal",
            component: "app-gantt-copy-modal",
            modalId: "gantt-copy-modal",
            url: "",
          },
          {
            title: this.$t("delete"),
            icon: "trash",
            type: "modal",
            component: "app-confirmation-modal",
            modalId: "gantt-delete-modal",
            url: "",
          },
        ],
      },
    };
  },
  methods: {
    getAction(rowData, actionObj, active) {
      if (actionObj.title == this.$t("edit")) {
        this.selectedUrl = `crm/gantts/${rowData.id}`;
        this.isGanttModalActive = true;
      } else if (actionObj.title == this.$t("delete")) {
        this.deleteUrl = `crm/gantts/${rowData.id}`;
        this.confirmationModalActive = true;
      } else if (actionObj.title == this.$t("copy")) {
        this.selectedUrl = `crm/gantts/${rowData.id}`;
        this.copy = true;
        this.isGanttModalActive = true;
      }
    },
    openModal() {
      this.isGanttModalActive = true;
    },
    openTypeModal() {
      this.isTypeModalActive = true;
    },
    closeTypeModal() {
      this.isTypeModalActive = false;
      this.selectedUrl = "";
      $("#gantt-type-modal").modal("hide");
    },
    closeModal() {
      this.isGanttModalActive = false;
      this.copy = false;
      this.selectedUrl = "";
      $("#gantt-modal").modal("hide");
    },

    commonActivityModal(activity) {
      this.editedUrl = `crm/activities/${activity.id}`;
      this.rowData = activity;
      this.ganttActivitiesModal = true;
    },

    closeViewAllModal() {
      this.viewAllDeal = false;
      $("#details-view-modal").modal("hide");
    },



  },
  computed: {
    ...mapGetters({
      organizationList: "getOrganization",
    }),
  },
  mounted() {
    this.getCustomFiled("gantt");
  },
};
</script>
<style>
.link-list {
  white-space: nowrap !important;
  max-width: 180px;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>
